export const VERIFIED_CONTENT_PULSE_KEY = 'automation-verified-content-spotlight';
